(function(){
    let innerBanner = document.querySelector('.has-banner');
    if (innerBanner) {
      document.body.classList.add('page-has-banner');
    }
})()



  let backBtn = document.querySelector('.btn--back');




  backBtn?.addEventListener('click', function () {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  });



//PRODUCT SLIDE
let prdSplideElement = document.querySelector('.prd-splide')
if(prdSplideElement){
  let prdSplide = new Splide( prdSplideElement, {
  direction: 'ttb',
  height: '55rem',
  gap: '10px',
  focus: 'center', 
  speed: 1000,
  wheel: true,
  releaseWheel: true,
  arrows: false,
  pagination: false,
  autoHeight: true, 
  throttle: 1,
  perPage: 1, 
  wheelSleep: 800,
    breakpoints: {
      480: {
        perPage: 2,
        direction: 'rtl',
        wheel: false,
        height: 'auto',
        pagination: true
      },
      767: {
        perPage: 3,
        direction: 'rtl',
        wheel: false,
        height: 'auto',
        pagination: true
      }
  },
  
});
prdSplide.mount();
document.addEventListener("DOMContentLoaded", function () {
  prdSplide.go(0);  // Start at the first slide (index 0)
});
  
}
